// React Query Provider - Cache mekanizması için
import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// DevTools'u opsiyonel olarak import et
let ReactQueryDevtools: React.ComponentType<{ initialIsOpen?: boolean }> | undefined;

// Query client konfigürasyonu
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Cache süresi: 5 dakika
      staleTime: 5 * 60 * 1000,
      // Cache'de tutma süresi: 10 dakika (React Query v5'te gcTime olarak değiştirildi)
      gcTime: 10 * 60 * 1000,
      // Otomatik yeniden fetch'i devre dışı bırak
      refetchOnWindowFocus: false,
      // Hata durumunda yeniden deneme
      retry: 3,
      // Yeniden deneme aralığı
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
    mutations: {
      // Mutation hata durumunda yeniden deneme
      retry: 1,
    },
  },
});

interface QueryProviderProps {
  children: React.ReactNode;
}

// Query Provider Component
export const QueryProvider: React.FC<QueryProviderProps> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* Toast Container */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {/* React Query DevTools - sadece development'ta */}
      {process.env.NODE_ENV === 'development' && ReactQueryDevtools && (
        <ReactQueryDevtools initialIsOpen={false} />
      )}
    </QueryClientProvider>
  );
};

export default queryClient;

